  <button appTooltip="Edit Feature"  [ngClass]="{'esk-tool--active' : active()===true}" class="esk-tool" (click)="toggleTool()" ><i class="fa fa-draw-polygon"></i></button>
  <ng-content></ng-content>
  @if (active()) {
    <ng-container
    intersectTool
    [intersectTargetLayers]="intersectTargetLayers()"
    [intersectTargetFeatures]="intersectTargetFeatures()"
    ></ng-container>
    <ng-container
    differenceTool
    [differenceTargetLayers]="differenceTargetLayers()"
    ></ng-container>
  }


